<template>
  <div class="login-firstTime">
    <div id="page-content-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-7 loginLeft">
            <img src="assets/images/login-graphic.png" alt="" />
          </div>

          <div class="col-md-5 loginRight">
            <div class="loginWrapper">
              <div class="loginText">
                <h2>
                  A confirmation code has been sent to the phone number
                  registered for this card
                </h2>
                <p class="registeredPhone">Enter confirmation code below:</p>
                <p class="registeredPhoneNum">
                  xxxxxxx{{ lastThreePhoneDigits }}
                </p>
              </div>

              <div class="loginControls regNo">
                <form action="form" @submit.prevent="sendConfirmCode">
                  <input
                    type="text"
                    maxlength="1"
                    id="digit1FirstTimeTac"
                    name="digit1"
                    v-model="digit1"
                    @keypress="onlyNumber"
                  />
                  <input
                    type="text"
                    maxlength="1"
                    id="digit2FirstTimeTac"
                    name="digit2"
                    v-model="digit2"
                    @keypress="onlyNumber"
                  />
                  <input
                    type="text"
                    maxlength="1"
                    id="digit3FirstTimeTac"
                    name="digit3"
                    v-model="digit3"
                    @keypress="onlyNumber"
                  />
                  <input
                    type="text"
                    maxlength="1"
                    id="digit4FirstTimeTac"
                    name="digit4"
                    v-model="digit4"
                    @keypress="onlyNumber"
                  />
                  <input
                    type="text"
                    maxlength="1"
                    id="digit5FirstTimeTac"
                    name="digit5"
                    v-model="digit5"
                    @keypress="onlyNumber"
                  />
                  <input
                    type="text"
                    maxlength="1"
                    id="digit6FirstTimeTac"
                    name="digit6"
                    v-model="digit6"
                    @keypress="onlyNumber"
                  />

                  <p class="remaining">
                    If you haven't received the confirmation code within 5
                    minutes please try again<br />
                  </p>
                  <button type="button">Send Again</button>
                  &nbsp;
                  <button
                    v-if="is2FALoginButtonLoading === true"
                    type="submit"
                    disabled
                  >
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Logging in...
                  </button>
                  <button
                    v-if="is2FALoginButtonLoading === false"
                    type="submit"
                  >
                    Login
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import actions from "@/store/authentication/actions";

export default {
  data: () => ({
    digit1: "",
    digit2: "",
    digit3: "",
    digit4: "",
    digit5: "",
    digit6: ""
  }),
  computed: {
    lastThreePhoneDigits: {
      get() {
        return this.$store.state.authentication.phone.slice(
          this.$store.state.authentication.phone.length - 3
        );
      }
    },
    is2FALoginButtonLoading: {
      get() {
        return this.$store.state.settings.is2FALoginButtonLoading;
      },
      set(value) {
        this.$store.commit("updateIs2FALoginButtonLoadingMutation", value);
      }
    }
  },
  methods: {
    onlyNumber: function($event) {
      const keyCode = $event.keyCode ? $event.keyCode : $event.which;
      const symbol = String.fromCharCode(keyCode);

      if (/^\s*$/.test(symbol) || isNaN(symbol)) {
        $event.preventDefault();
      } else {
        const inputId = $event.target.id;

        switch (inputId) {
          case "digit1FirstTimeTac":
            this.digit1 = symbol;
            break;
          case "digit2FirstTimeTac":
            this.digit2 = symbol;
            break;
          case "digit3FirstTimeTac":
            this.digit3 = symbol;
            break;
          case "digit4FirstTimeTac":
            this.digit4 = symbol;
            break;
          case "digit5FirstTimeTac":
            this.digit5 = symbol;
            break;
          case "digit6FirstTimeTac":
            this.digit6 = symbol;
            break;
          default:
            break;
        }

        $event.preventDefault();
        $event.target.nextElementSibling.focus();
      }
    },
    sendConfirmCode: function() {
      const twoFactorLoginCode = `${this.digit1}${this.digit2}${this.digit3}${this.digit4}${this.digit5}${this.digit6}`;

      if (twoFactorLoginCode.length != 6) {
        this.$store.commit(
          "updateGenericErrorModalMessageMutation",
          "Sms code was not entered"
        );
        this.$store.commit("updateIsGenericErrorModaleActiveMutation", true);
        return;
      }

      this.is2FALoginButtonLoading = true;
      this.$store.dispatch(actions.TWO_FACTOR_LOGIN, twoFactorLoginCode);
    }
  }
};
</script>
